(function () {
  'use strict';

  angular
    .module('consecutiveDayFlightAndEarlyMorningDeparture')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('consecutiveDayFlightAndEarlyMorningDeparture', {
        url: '/consecutive-day-flight-and-early-morning-departure',
        views: {
          'dayAndEarlyMorningFlightView': {
            templateUrl: 'day-and-early-morning-flight-report/views/day-and-early-morning-flight.tpl.html',
            controller: 'DayAndEarlyMorningFlightCtrl',
            controllerAs: 'dayAndEarlyMorningFlight'
          }
        }
      });
  }
}());
